import { Field, Radio, TextArea, Typography } from '@/components';
import { CreateOfferFormFields } from '@/features/offers';
import { CreateOpportunityFormFields } from '@/features/opportunities';
import { nullableStringSetter } from '@/helpers';
import { FormState, UseFormRegister } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export type AdvisoryServiceFormFields = CreateOfferFormFields | CreateOpportunityFormFields;

export type AdvisoryServiceProps = {
  readonly register: UseFormRegister<AdvisoryServiceFormFields>;
  readonly formState: FormState<AdvisoryServiceFormFields>;
};

export function AdvisoryServiceForm({ register, formState }: AdvisoryServiceProps) {
  const { t } = useTranslation(['services']);
  const areAllSelected =
    formState.errors['advisory_service_information'] &&
    Object.values(formState.errors['advisory_service_information']).some((service) => service !== '');
  return (
    <>
      {areAllSelected && (
        <Typography size="body-2" color="error">
          All fields in this section are required
        </Typography>
      )}
      <Field
        id="legal_advisors"
        label={t('Do you need a Legal Advisor?')}
        delay={0.9}
        classes={{ input: 'flex flex-wrap gap-6', field: 'space-y-1 grid grid-cols-1 sm:grid-cols-2' }}
      >
        <Radio
          id="legal_advisors_yes"
          color={formState.errors['advisory_service_information']?.legal_advisors ? 'error' : 'primary'}
          registration={register('advisory_service_information.legal_advisors', {
            required: t('This field is required'),
          })}
          value="yes"
        >
          <Typography as="p" color="secondary" size="body-2" weight="normal">
            {t('Yes')}
          </Typography>
        </Radio>
        <Radio
          id="legal_advisors_no"
          color={formState.errors['advisory_service_information']?.legal_advisors ? 'error' : 'primary'}
          registration={register('advisory_service_information.legal_advisors', {
            required: t('This field is required'),
          })}
          value="no"
        >
          <Typography as="p" color="secondary" size="body-2" weight="normal">
            {t('No')}
          </Typography>
        </Radio>
        {/* <Radio
          id="legal_advisors_maybe"
          color={formState.errors['advisory_service_information']?.legal_advisors ? 'error' : 'primary'}
          registration={register('advisory_service_information.legal_advisors', {
            required: t('This field is required'),
          })}
          value="maybe"
        >
          <Typography as="p" color="secondary" size="body-2" weight="normal">
            {t('Maybe')}
          </Typography>
        </Radio> */}
      </Field>

      <Field
        id="financial_advisors"
        label={t('Do you need a Financial Advisor?')}
        delay={0.9}
        classes={{ input: 'flex flex-wrap gap-6', field: 'space-y-1 grid grid-cols-1 sm:grid-cols-2' }}
      >
        <Radio
          id="financial_advisors_yes"
          color={formState.errors['advisory_service_information']?.financial_advisors ? 'error' : 'primary'}
          registration={register('advisory_service_information.financial_advisors', {
            required: t('This field is required'),
          })}
          value="yes"
        >
          <Typography as="p" color="secondary" size="body-2" weight="normal">
            {t('Yes')}
          </Typography>
        </Radio>
        <Radio
          id="financial_advisors_no"
          color={formState.errors['advisory_service_information']?.financial_advisors ? 'error' : 'primary'}
          registration={register('advisory_service_information.financial_advisors', {
            required: t('This field is required'),
          })}
          value="no"
        >
          <Typography as="p" color="secondary" size="body-2" weight="normal">
            {t('No')}
          </Typography>
        </Radio>
        {/* <Radio
          id="financial_advisors_maybe"
          color={formState.errors['advisory_service_information']?.financial_advisors ? 'error' : 'primary'}
          registration={register('advisory_service_information.financial_advisors', {
            required: t('This field is required'),
          })}
          value="maybe"
        >
          <Typography as="p" color="secondary" size="body-2" weight="normal">
            {t('Maybe')}
          </Typography>
        </Radio> */}
      </Field>

      <Field
        id="technical_advisors"
        label={t('Do you need a Technical Advisor?')}
        delay={0.9}
        classes={{ input: 'flex flex-wrap gap-6', field: 'space-y-1 grid grid-cols-1 sm:grid-cols-2' }}
      >
        <Radio
          id="technical_advisors_yes"
          color={formState.errors['advisory_service_information']?.technical_advisors ? 'error' : 'primary'}
          registration={register('advisory_service_information.technical_advisors', {
            required: t('This field is required'),
          })}
          value="yes"
        >
          <Typography as="p" color="secondary" size="body-2" weight="normal">
            {t('Yes')}
          </Typography>
        </Radio>
        <Radio
          id="technical_advisors_no"
          color={formState.errors['advisory_service_information']?.technical_advisors ? 'error' : 'primary'}
          registration={register('advisory_service_information.technical_advisors', {
            required: t('This field is required'),
          })}
          value="no"
        >
          <Typography as="p" color="secondary" size="body-2" weight="normal">
            {t('No')}
          </Typography>
        </Radio>
        {/* <Radio
          id="technical_advisors_maybe"
          color={formState.errors['advisory_service_information']?.technical_advisors ? 'error' : 'primary'}
          registration={register('advisory_service_information.technical_advisors', {
            required: t('This field is required'),
          })}
          value="maybe"
        >
          <Typography as="p" color="secondary" size="body-2" weight="normal">
            {t('Maybe')}
          </Typography>
        </Radio> */}
      </Field>

      <Field
        id="epc_service"
        label={t('Do you need an EPC?')}
        delay={0.9}
        classes={{ input: 'flex flex-wrap gap-6', field: 'space-y-1 grid grid-cols-1 sm:grid-cols-2' }}
      >
        <Radio
          id="epc_service_yes"
          color={formState.errors['advisory_service_information']?.epc_service ? 'error' : 'primary'}
          registration={register('advisory_service_information.epc_service', {
            required: t('This field is required'),
          })}
          value="yes"
        >
          <Typography as="p" color="secondary" size="body-2" weight="normal">
            {t('Yes')}
          </Typography>
        </Radio>
        <Radio
          id="epc_service_no"
          color={formState.errors['advisory_service_information']?.epc_service ? 'error' : 'primary'}
          registration={register('advisory_service_information.epc_service', {
            required: t('This field is required'),
          })}
          value="no"
        >
          <Typography as="p" color="secondary" size="body-2" weight="normal">
            {t('No')}
          </Typography>
        </Radio>
        {/* <Radio
          id="epc_service_maybe"
          color={formState.errors['advisory_service_information']?.epc_service ? 'error' : 'primary'}
          registration={register('advisory_service_information.epc_service', {
            required: t('This field is required'),
          })}
          value="maybe"
        >
          <Typography as="p" color="secondary" size="body-2" weight="normal">
            {t('Maybe')}
          </Typography>
        </Radio> */}
      </Field>

      {/* <Field
        id="o&m_advisors"
        label={t('Do you need an O&M or Asset Manager?')}
        delay={0.9}
        classes={{ input: 'flex flex-wrap gap-4', field: 'space-y-1 grid grid-cols-1 sm:grid-cols-2' }}
      >
        <Radio
          id="o&m_advisors_yes"
          color={formState.errors['advisory_service_information']?.om_service ? 'error' : 'primary'}
          registration={register('advisory_service_information.om_service', {
            required: t('This field is required'),
          })}
          value="yes"
        >
          <Typography as="p" color="secondary" size="body-2" weight="normal">
            {t('Yes')}
          </Typography>
        </Radio>
        <Radio
          id="o&m_advisors_no"
          color={formState.errors['advisory_service_information']?.om_service ? 'error' : 'primary'}
          registration={register('advisory_service_information.om_service', {
            required: t('This field is required'),
          })}
          value="no"
        >
          <Typography as="p" color="secondary" size="body-2" weight="normal">
            {t('No')}
          </Typography>
        </Radio>
        <Radio
          id="o&m_advisors_maybe"
          color={formState.errors['advisory_service_information']?.om_service ? 'error' : 'primary'}
          registration={register('advisory_service_information.om_service', {
            required: t('This field is required'),
          })}
          value="maybe"
        >
          <Typography as="p" color="secondary" size="body-2" weight="normal">
            {t('Maybe')}
          </Typography>
        </Radio>
      </Field>

      <Field
        id="other"
        label={t('Do you need any other service? (optional)')}
        error={formState.errors['advisory_service_information']?.other}
        delay={0}
        classes={{ field: 'space-y-1' }}
      >
        <TextArea
          id="other"
          color={formState.errors['advisory_service_information']?.other ? 'error' : 'primary'}
          registration={register('advisory_service_information.other', {
            setValueAs: nullableStringSetter,
          })}
        />
      </Field> */}
    </>
  );
}
